module.exports = __webpack_public_path__ + "img/YogaRetreat.30fb29e5.jpeg";